
import React from 'react';

const Popup = () => {
    return (
        <div style={popupStyle}>
            <p>No internet connection. Please check </p>
        </div>
    );
};

const popupStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    fontFamily: 'poppins',
    transform: 'translate(-50%, -50%)',
    padding: '20px',
    backgroundColor: '#e34242',
    color: 'white',
    borderRadius: '10px',
    textAlign: 'center',
    zIndex: 1000
};

export default Popup;